<template>
  <div>
    <div class="pa-6">
      <p class="font-weight-medium">
        {{ $t("multi_url.description") }}
      </p>

      <div class="mt-6 div-documents" v-if="documentList && documentList.length">
        <p>
          <span class="font-weight-bold">{{ $t("multi_url.documents") }}</span>
        </p>

        <v-list class="document-item bullet-list" dense flat light>
          <v-list-item v-for="(document, index) in documentList" :key="index" tag="div">
            <v-list-item-content>
              <v-list-item-title class="text--secondary">
                {{ document.signatureTransaction.description }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
        <!-- ✅ Alerta si todos los documentos están firmados -->
        <v-alert
          v-if="allDocumentsSigned"
          type="success"
          class="mt-4"
          border="left"
          colored-border
          elevation="2"
        >
          {{ $t("multi_url.all_documents_signed") }}
        </v-alert>
    </div>


    <div class="footer-message">
      <v-container class="px-2 fill-height">
        <v-row>
          <v-col cols="12" class="d-flex align-start">
            <v-checkbox dark v-model="termsAccepted" class="custom-checkbox" :disabled="!documentList.length"></v-checkbox>
            <p class="ml-2">
              {{ $t("multi_url.agreement") }}
              <a href="https://www.portasigma.com/politica-privacidad/" target="_blank" class="footer-link"
                rel="noopener">{{ $t("multi_url.privacy_policy") }}</a>
            </p>
          </v-col>
          <v-col cols="12">
            <v-btn x-large block class="footer-text-btn" :disabled="!termsAccepted" :loading="loading"
              @click="goToList()">
              {{ $t("multi_url.enter_to_sign") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <access-modal :typeOfId="firstDocumentType" :dialog="visibleAccessDialog" :documentId="firstDocId" :documentToken="accessToken"
      :documentName="documentName" @closeModal="closeAccessModal()" />

    <default-loading v-if="loading" :loading="loading" />
  </div>
</template>

<script>
import AccessModal from "../../components/shared/AccessModal.component";
import DefaultLoading from "../shared/DefaultLoading.component";

import { SignaturesService } from '../../services/multiple/signatures-service';
import UploadService from '../../services/multiple/upload-service.js';
import { EventBus } from "@/event-bus"; // Ajusta la ruta según tu proyecto

export default {
  components: {
    DefaultLoading,
    AccessModal,
  },
  data() {
    return {
      termsAccepted: false,
      loading: false,
      documentList: [],
      token: null,
      authId: null,
      visibleAccessDialog: false,
      documentId: null,
      documentToken: null,
      documentName: null,
    }
  },
  mounted() {
    this.saveAssociationName();
    this.$nextTick(() => {
        console.log("🎯 overlayColor en mounted + DOM listo:", this.overlayColor);
      });
  },


  computed: {
    buttonColor(){
        return this.$store.state.common.buttonColor;
    },
    overlayColor(){
        return this.$store.state.common.appBarColor;
    },

    buttonTextColor() {
        return this.$store.state.common.buttonTextColor;
    },
    hasAssociation() {
      return this.$store.getters['common/hasAssociation']
    },
    firstDocumentType() {
        return this.documentList.length > 0 ? this.documentList[0].typeOfId : "";
      },
    accessToken() {
      return this.documentList.length > 0 ? this.documentList[0].apiToken : "";
    },
    firstDocId() {
        return this.documentList.length > 0 ? this.documentList[0].id : "";
    },
    allDocumentsSigned() {
        return this.documentList.length > 0 && this.documentList.every(doc => doc.signed === true);
      }

  },
  methods: {
    saveAssociationName() {
        // Extrae la parte del path (ej: /noregister/summary)
        const path = this.$route.path;

        // Divide por "/" y toma el primer segmento no vacío
        const parts = path.split('/').filter(p => p); // ['noregister', 'summary']
        const association = parts[0];

        if (association) {
          localStorage.setItem('currentAssociation', association);
          console.log(`Asociación guardada: ${association}`);
        } else {
          console.warn('No se pudo determinar la asociación desde la ruta.');
        }
      },

    goToList() {
        console.log("Ejecutando goToList");
        console.log("CitizenId: " + this.citizenId);
        console.log("Overlay Color: " + this.overlayColor);
        localStorage.setItem("formIndex", 0);

        if (!this.authCitizenId) {
            // Si no hay authCitizenId, redirigir directamente a DocumentList
            const routeName = this.hasAssociation ? "custom-multiple-pdf" : "multiple-pdf";
            this.$router.push({ name: routeName });
            console.log(this.authCitizenId);
        } else {
            // Si hay authCitizenId, abrir el diálogo de autenticación antes de redirigir
            console.log("OverlayColor al visualizar AccessModal:", this.overlayColor);
            this.visibleAccessDialog = true;
        }
    },



    async loadDocumentList() {
      this.loading = true;
      this.$store.commit('common/beginCustomizationBatch');
      const customizationEpoch = this.$store.state.common.customizationBatchEpoch;
      this.$store.commit('common/setCustomizationCurrent', null);
      localStorage.setItem("list", "true");
      localStorage.removeItem("user");

      SignaturesService.getBatchCertificateSignatureRequests(this.token, this.authId)
        .then(async (response) => {
          if (customizationEpoch !== this.$store.state.common.customizationBatchEpoch) return;
          this.documentList = response.data.signatureRequestsList || [];
          this.$store.commit('common/completeCustomizationBatch', { epoch: customizationEpoch, list: this.documentList });
          const nameToShow = this.documentList.length ? this.documentList[0].signerName : "";
          localStorage.setItem("user_name", nameToShow);
                  EventBus.$emit('refresh-user');

          if (!localStorage.getItem('documentCheckList')) {
            await this.createDocumentCheckList(customizationEpoch);
          }

          if (customizationEpoch === this.$store.state.common.customizationBatchEpoch) this.loading = false;
        })
        .catch(() => {
          if (customizationEpoch !== this.$store.state.common.customizationBatchEpoch) return;
          this.$store.commit('common/completeCustomizationBatch', { epoch: customizationEpoch, list: [] });
          this.loading = false;
        });
    },

    //Get Uploaded Attachment Count
    async getUploadedDocCount($request_id, $request_token, $request_auth_id = null) {
      const attachments = await UploadService.getAttachments($request_id, $request_token, $request_auth_id);
      return attachments.data.length;
    },
    // Create Document Check List

async createDocumentCheckList(customizationEpoch) {
//    console.log("Creando CheckList");
    let documentCheckList = [];

    for (const document of this.documentList) {
        if (customizationEpoch !== this.$store.state.common.customizationBatchEpoch) return;
        let docCount = 0;

        // Obtener el número de documentos subidos
        if (document.signerId == null) {
            docCount = await this.getUploadedDocCount(document.id, document.apiToken, null);
        } else {
            docCount = await this.getUploadedDocCount(document.id, document.apiToken, document.signerId.id);
        }

        if (customizationEpoch !== this.$store.state.common.customizationBatchEpoch) return;
        docCount = Number(docCount);
        if (isNaN(docCount)) {
            console.error('docCount is not a number:', docCount);
            docCount = 0;
        }

        // Crear una copia del documento original con los nuevos campos añadidos
        let newDocument = { ...document };  // Copia el objeto original
        newDocument.uploadedDocCount = docCount;  // Añade docCount
        newDocument.checkId = this.authCitizenId === 'citizenid';
        newDocument.idChecked = false;
        newDocument.checkAttachments = document.hasAttachments;
        newDocument.attachmentsChecked = false;
        newDocument.checkSignerForm = document.hasSignerForm;
        newDocument.signerFormChecked = false;

        documentCheckList.push(newDocument);
    }
//    console.log("documentCheckList creada");

    // Guardar en localStorage con el mismo formato que documentList
    if (customizationEpoch !== this.$store.state.common.customizationBatchEpoch) return;
    if (documentCheckList.length > 0) {
//        console.log("seteando valores");
        let originalJsonData = JSON.stringify(documentCheckList);
        let parsedList = JSON.parse(originalJsonData);
        localStorage.setItem('documentCheckList', parsedList);
        console.log("documentCheckList guardada en Storage");
        this.type=parsedList[0]?.type;
//        console.log("Type: " + this.type);
        this.documentToken = parsedList[0]?.apiToken;
        this.requestId = parsedList[0]?.id;
//        console.log("documentToken: " + this.documentToken);
//        console.log("requestID: " + this.requestId);
        if (this.type === "ONETIMEWITHID") {
            this.authCitizenId = true;
            }
         console.log("authCitizenId: " + this.authCitizenId);
         localStorage.setItem("authCitizenId", this.authCitizenId);
         localStorage.setItem("access_token",this.apiToken);

//        localStorage.setItem("type", this.documentCheckList[0].type ? this.documentList[0].type : "");
//        localStorage.setItem("multiotp", this.documentCheckList[0].otp ? this.documentList[0].otp : "");
//        localStorage.setItem("multipad", this.documentCheckList[0].pad ? this.documentList[0].pad : "");
    } else {
//        console.log('documentCheckList is empty, nothing to store.');
    }
},

    signDocument() {
      console.log("authCitizenId: " + this.authCitizenId);
      let documentCheckList = localStorage.getItem("documentCheckList") ? JSON.parse(localStorage.getItem("documentCheckList")) : [];
      let firstDoc = documentCheckList && documentCheckList.length ? documentCheckList[0] : null;
      localStorage.setItem("access_token", firstDoc.apiToken);
//      console.log("Token de autenticacion: " + firstDoc.apiToken);
      if (this.authCitizenId) {
        if (firstDoc.checkId && !firstDoc.idChecked) {
          this.documentId = firstDoc.documentId;
          this.documentToken = firstDoc.documentToken;
          this.documentName = firstDoc.documentName;
          this.visibleAccessDialog = true;
        }
      }
    },

    signOneTimeDocument() {
      let documentCheckList = localStorage.getItem("documentCheckList") ? JSON.parse(localStorage.getItem("documentCheckList")) : [];
      let firstDoc = documentCheckList && documentCheckList.length ? documentCheckList[0] : null;
      this.confirmOneTimeRequest(firstDoc.documentId, firstDoc.documentToken);
    },
    closeAccessModal() {
      this.visibleAccessDialog = false;
    },
    viewDocument(document) {
      this.$router.push({ name: `${this.hasAssociation ? 'custom-' : ''}show-document`, params: { id: document.id }, query: { token: document.apiToken, authId: this.authId } });
    },
    confirmOneTimeRequest(requestID, requestToken) {
      this.error = false;
      this.errorMsg = "";
      SignaturesService.getSignatureRequestDataAuth(
        requestID,
        this.citizenId,
        false,
        requestToken
      )
        .then(() => {
          this.error = false;
          this.loading = false;
          this.checkForNextStep();

        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status == 403) {
            this.error = true;
            this.errorMsg = error.response.data.description;
          }
        });

    },
    async checkForNextStep() {
      let documentCheckList = localStorage.getItem("documentCheckList") ? JSON.parse(localStorage.getItem("documentCheckList")) : [];

      // Update the document checklist after all status updates are completed
      documentCheckList.forEach((document) => {
        document.checkId = false;
        document.idChecked = true;
        document.isMultiple = true;
      });

      localStorage.setItem('documentCheckList', JSON.stringify(documentCheckList));

      // Using a for...of loop to handle async/await
      for (const [index, document] of documentCheckList.entries()) {
        console.log(index);
        await this.updateDocumentStatus(document, this.citizenId); // Await ensures each update completes before continuing
      }



      // Check for next steps after updating statuses
      for (const document of documentCheckList) {

        if (document.uploadedDocCount > 0) {
          this.$router.push({
            name: `${this.hasAssociation ? 'custom-' : ''}multiple-forms`,
            params: { id: document.documentId },
            query: {
              ...this.$route.query,
              token: document.documentToken,
              auth_id: this.citizenId,
              document_name: document.documentName
            }
          });
          break;
        } else if (document.checkAttachments && !document.attachmentsChecked) {
          this.$router.push({
            name: `${this.hasAssociation ? 'custom-' : ''}multiple-attachments`,
            params: { id: document.documentId },
            query: {
              ...this.$route.query,
              token: document.documentToken,
              auth_id: this.citizenId,
              document_name: document.documentName
            }
          });

          break;
        } else if (document.checkSignerForm && !document.signerFormChecked && document.checkAttachments && (document.uploadedDocCount > 0)) {

          this.$router.push({
            name: `${this.hasAssociation ? 'custom-' : ''}multiple-forms`,
            params: { id: document.documentId },
            query: {
              ...this.$route.query,
              token: document.documentToken,
              auth_id: this.citizenId,
              document_name: document.documentName
            }
          });
        }
      }
    },

    //update document attachments and form status
    async updateDocumentStatus(document) {
      let documentRequestID = document.documentId;
      let currentDocumentToken = document.documentToken;

      try {
        const response = await SignaturesService.getSignatureRequestDataAuth(
          documentRequestID,
          this.citizenId,
          this.isAuthCitizenId,
          currentDocumentToken
        );
        this.error = false;
        this.loading = false;
        let documentCheckList = localStorage.getItem("documentCheckList") ? JSON.parse(localStorage.getItem("documentCheckList")) : [];
        documentCheckList.forEach((document) => {
          const signerAuthId = response.data.signerId !== null ? response.data.signerId.id : null;
          if (document.documentId == response.data.id) {
            document.hasAttachments = response.data.hasAttachments;
            document.checkAttachments = response.data.hasAttachments,
              document.hasPendingSignerForm = response.data.hasPendingSignerForm;
            document.hasSignerForm = response.data.hasSignerForm;
            document.checkSignerForm = response.data.hasSignerForm;
            document.auth_id = signerAuthId;
          }
        });

        localStorage.setItem('documentCheckList', JSON.stringify(documentCheckList));


      } catch (error) {
        this.loading = false;
        if (error.response.status == 403) {
          this.error = true;
          this.errorMsg = error.response.data.description;
        }
      }
    }
  },


  created() {
    this.token = this.$route.query.token || null;
    this.authCitizenId = this.$route.query.auth || null;
    this.authId = this.$route.query.authId || null;
    console.log("Token: " + this.token);

    if (this.token) {
      localStorage.removeItem("multiple_Token");
      localStorage.removeItem("documentCheckList");
      localStorage.removeItem("auth_user_token");
      localStorage.setItem("file_name", null);
      localStorage.setItem("transaction_id", null);
      localStorage.setItem("access_token", "");
      localStorage.setItem("auth_id", "");
      localStorage.setItem("request_id", "");
      localStorage.setItem("type", "");
      localStorage.setItem("formAnswers", "");
      localStorage.setItem("reviewed_list", "");
      localStorage.setItem("pdfjs.history", "");
      localStorage.setItem("authCitizenId", "");
      localStorage.setItem("multiple_token", this.token);
      localStorage.setItem("list", "true");
      localStorage.setItem("formIndex", 0);
      localStorage.setItem("attachIndex", 0);
      this.loadDocumentList();
    }
  },
}
</script>

<style lang="scss" scoped>
.div-documents {
  p {
    margin-bottom: 0px;
  }

  .document-item {
    margin-left: 15px;
  }

  .v-list {
    padding: 0;
  }

  .v-list-item {
    background-color: #fff;
  }
}

.v-input--checkbox {
  margin-top: 0px !important;
}

.bullet-list .v-list-item::before {
  content: '•';
  /* Unicode character for a bullet */
  color: black;
  /* Bullet color */
  display: inline-block;
  width: 1em;
  /* Space before bullet */
  margin-left: -1em;
  /* Pull bullet outside the content */
}
